import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const container = useRef();
  const [activeMenu, setactiveMenu] = useState(false);

  const menuData = [
    {
      url: '/',
      menu: 'home',
    },
    {
      url: '/news',
      menu: 'news',
    },
    {
      url: '/gold',
      menu: 'gold rates',
    },
    {
      url: '/silver',
      menu: 'silver rates',
    },
    {
      url: '/ipo',
      menu: 'IPO',
    },
    {
      url: '/currency',
      menu: 'currency',
    },
  ]

  useEffect(
    () => {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "symbols": [
            {
              "proName": "FX_IDC:XAUINRG",
              "title": "GOLD"
            },
            {
              "proName": "FX_IDC:XAGINRK",
              "title": "SILVER"
            },
            {
              "proName": "FX_IDC:USDINR",
              "title": "USDINR"
            },
            {
              "proName": "PYTH:WTI3!",
              "title": "CRUDE OIL"
            }
          ],
          "colorTheme": "light",
          "locale": "en",
          "largeChartUrl": "",
          "isTransparent": true,
          "showSymbolLogo": true,
          "displayMode": "regular"
        }`;
      container.current.appendChild(script);
    },
    []
  );

  useEffect(() => {
    if (activeMenu) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [activeMenu]);


  return (<>
    <header>
      <div className="container">
        <div className="row">
          <div className="main-menu">
            <div className="logo">
              <NavLink to="/" aria-label="logo" onClick={()=> [
                 window.scrollTo({ top: 0, behavior: 'smooth' })
              ]}>
                <img src="https://makawanacs.com/themes/custom/mcs/img/footer-logo.png" alt="logo" />
              </NavLink>
            </div>
            <div className={`menubar ${activeMenu ? "active" : ""}`}>
              <ul>
                {
                  menuData?.map(({ menu, url }, index) => {
                    return (
                      <li key={index}>
                        <NavLink to={url} onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' })
                          setactiveMenu(false)
                        }}>{menu}
                        </NavLink>
                      </li>
                    )
                  })
                }
              </ul>
            </div>
            <div className="hamburger-icon">
              <label className={`hamburger ${activeMenu ? "active" : ""}`} onClick={() => {
                setactiveMenu(!activeMenu)
              }} aria-label="Toggle menu">
                <svg viewBox="0 0 32 32">
                  <path className="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
                  <path className="line" d="M7 16 27 16"></path>
                </svg>
              </label>
            </div>
          </div>
        </div>
      </div>
    </header >
    <div className="rate-slider" style={{ background: "white", position: "sticky", top: "71px", zIndex: "98 " }}>
      <div className="rate" style={{ width: "100%", margin: "auto", padding: "0" }}>
        <div className="tradingview-widget-container" ref={container} >
          <div className="tradingview-widget-container__widget"></div>
        </div>
      </div >
    </div>
  </>)
}

export default Header;